export const TABS_TEST_ID = {
  button: 'tabs-button',
  tag: 'tabs-button-tag',
};
